
export class AxiosError extends Error {
    constructor(error, t) {
      let message = t?.("error.network.unexpected") || "An unexpected error occurred. Please try again.";
  
      if (error.response) {
        const status = error.response.status;
  
        if (status >= 500) {
          message = t?.("error.network.server") || "Our servers are currently unavailable. Please try again later.";
        } else if (status === 400) {
          message = t?.("error.network.validation") || "There was a problem with your input. Please review the form.";
        } else if (status === 401 || status === 403) {
          message = t?.("error.network.unauthorized") || "You are not authorized to perform this action.";
        } else {
          message = error.response.data?.message || (t?.("error.unknown") || "Something went wrong with your request.");
        }
      } else if (error.request) {
        message = t?.("error.network.network") || "Could not reach the server. Please check your internet connection.";
      } else if (error.message) {
        message = error.message;
      }
  
      super(message);
  
      this.name = "CustomAxiosError";
      this.original = error;
      this.status = error?.response?.status;
      this.data = error?.response?.data;
      this.isAxiosError = true;
    }
  }
  